const sortObjectByDateProperty = key => (a, b) => {
	return new Date(b[key]) - new Date(a[key]);
}
export default sortObjectByDateProperty;